<template>
  <div class="jl-sub-content-wrap">
    <div class="jl-container">
      <div class="jl-sub-side-wrap">
        <div class="jl-sub-side-nav">
          <v-subSideNav></v-subSideNav>
        </div>
        <div class="jl-sub-side-main">
          <div class="jl-sub-side-main-bread">
            <v-breadcrumbs></v-breadcrumbs>
          </div>

          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubSideNav from "./SubSideNav";
import Breadcrumbs from "@/components/Breadcrumbs";
export default {
  components: {
    "v-subSideNav": SubSideNav,
    "v-breadcrumbs": Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-sub-side-wrap {
  position: relative;
  padding-left: 184px;
  min-height: 527px;
  .jl-sub-side-nav {
    position: absolute;
    left: 0;
    top: 0;
    width: 165px;
    height: 100%;
    background: #fff;
  }
}
.jl-sub-side-main {
  position: relative;
  min-height: 527px;
  background: #fff;
  padding-top: 50px;
  .jl-sub-side-main-bread {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    background: #f8f8fb;
  }
}
.jl-sub-content-wrap {
  background: #f8f8fb;
  padding-bottom: 120px;
}
</style>
